function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M9.5.5a6 6 0 00-6 6v3H2A1.5 1.5 0 00.5 11v9A1.5 1.5 0 002 21.5h15a1.5 1.5 0 001.5-1.5v-9A1.5 1.5 0 0017 9.5h-1.5v-3a6 6 0 00-6-6zm3 9v-3a3 3 0 10-6 0v3h6z",
  fill: "#F4F6F8"
});

var SvgLock = function SvgLock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 22,
    viewBox: "0 0 19 22",
    fill: "none"
  }, props), _ref);
};

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTkiIGhlaWdodD0iMjIiIHZpZXdCb3g9IjAgMCAxOSAyMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik05LjUgMC41QzYuMTg2MjkgMC41IDMuNSAzLjE4NjI5IDMuNSA2LjVWOS41SDJDMS4xNzE1NyA5LjUgMC41IDEwLjE3MTYgMC41IDExVjIwQzAuNSAyMC44Mjg0IDEuMTcxNTcgMjEuNSAyIDIxLjVIMTdDMTcuODI4NCAyMS41IDE4LjUgMjAuODI4NCAxOC41IDIwVjExQzE4LjUgMTAuMTcxNiAxNy44Mjg0IDkuNSAxNyA5LjVIMTUuNVY2LjVDMTUuNSAzLjE4NjI5IDEyLjgxMzcgMC41IDkuNSAwLjVaTTEyLjUgOS41VjYuNUMxMi41IDQuODQzMTUgMTEuMTU2OSAzLjUgOS41IDMuNUM3Ljg0MzE1IDMuNSA2LjUgNC44NDMxNSA2LjUgNi41VjkuNUgxMi41WiIgZmlsbD0iI0Y0RjZGOCIvPgo8L3N2Zz4K";
export { SvgLock as ReactComponent };